module.exports = __webpack_public_path__ + "img/thumbnail_BighornSheep_j_leucistic.2b80768b.png";